export class PersonelPermissionEntity {
    id: number | null = null;
    parent: PersonelPermissionEntity|null = null;
    children: Array<object> = [];
    name: string | null = null;
    label: string |null = null;

}
